import { render, staticRenderFns } from "./Cupom.vue?vue&type=template&id=ea8c74be&scoped=true"
import script from "./Cupom.vue?vue&type=script&lang=js"
export * from "./Cupom.vue?vue&type=script&lang=js"
import style0 from "./Cupom.vue?vue&type=style&index=0&id=ea8c74be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8c74be",
  null
  
)

export default component.exports